// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-md + .item-inner ion-label {
  margin-left: 14px;
}

.checkbox-md {
  padding-left: 0px;
}

.item-checkbox .label {
  font-size: 1.5rem;
  color: #3D3D3D;
  font-weight: 400;
}

.text-input[disabled] {
  opacity: 0.6;
}

.labels {
  opacity: 100% !important;
}

.input-disabled.sc-ion-input-md-h {
  opacity: 0.8;
  color: var(--ion-color-dark);
  pointer-events: none;
}

.input-disabled.sc-ion-input-ios-h {
  opacity: 1 !important;
  -webkit-text-fill-color: var(--ion-color-dark);
  pointer-events: none;
  color: var(--ion-color-dark);
}

.autoaddress-container {
  z-index: 9999;
  margin-top: -6px !important;
  right: 5px !important;
  width: 92%;
  margin-left: 17px;
  border: 1px solid #ccc;
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 50vh;
}
@media screen and (max-width: 768px) {
  .autoaddress-container {
    max-height: 35vh;
  }
}
.autoaddress-container .autoaddress-container {
  margin-top: 0 !important;
}
.autoaddress-container .autoaddress-items-med a {
  font-size: 1rem;
  cursor: pointer;
  padding-left: 8px !important;
}

ion-list.no-padding {
  padding-top: 0px;
  padding-bottom: 0px;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

ion-toolbar {
  display: block !important;
}

@media screen and (max-width: 550px) {
  ion-title {
    font-size: 13px !important;
  }
}
ion-ripple-effect {
  color: var(--ion-color-light);
}

ion-title {
  text-align: center;
  transform: translateY(-8px);
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.promo-text {
  margin: 15px 0 !important;
  font-weight: 400 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/information-and-security/personal-information/personal-information.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AACA;EACE,YAAA;EACA,4BAAA;EACA,oBAAA;AAEF;;AAAA;EACE,qBAAA;EACA,8CAAA;EACA,oBAAA;EAEF,4BAAA;AAEA;;AAEA;EACE,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,2CAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;AACF;AACE;EAZF;IAaI,gBAAA;EAEF;AACF;AAAE;EACE,wBAAA;AAEJ;AAEI;EACE,eAAA;EACA,eAAA;EACA,4BAAA;AAAN;;AAKA;EACE,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE;IACE,0BAAA;EAFF;AACF;AAUA;EACE,6BAAA;AARF;;AAWA;EACE,kBAAA;EACA,2BAAA;AARF;;AAWA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AARF;;AAWA;EACE,yBAAA;EACA,2BAAA;AARF","sourcesContent":[".checkbox-md+.item-inner ion-label {\n  margin-left: 14px;\n}\n\n.checkbox-md {\n  padding-left: 0px;\n}\n\n.item-checkbox .label {\n  font-size: 1.5rem;\n  color: #3D3D3D;\n  font-weight: 400;\n}\n\n.text-input[disabled] {\n  opacity: 0.6;\n}\n\n.labels {\n  opacity: 100% !important;\n}\n.input-disabled.sc-ion-input-md-h{\n  opacity: .80; \n  color: var(--ion-color-dark); \n  pointer-events: none; \n}\n.input-disabled.sc-ion-input-ios-h {\n  opacity: 1 !important; \n  -webkit-text-fill-color:var(--ion-color-dark);  \n  pointer-events: none; \n\ncolor:var(--ion-color-dark); \n  \n}\n\n.autoaddress-container {\n  z-index: 9999;\n  margin-top: -6px !important;\n  right: 5px !important;\n  width: 92%;\n  margin-left: 17px;\n  border: 1px solid #ccc;\n  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  max-height: 50vh;\n\n  @media screen and (max-width: 768px) {\n    max-height: 35vh;\n  }\n\n  .autoaddress-container {\n    margin-top: 0 !important;\n  }\n\n  .autoaddress-items-med {\n    a {\n      font-size: 1rem;\n      cursor: pointer;\n      padding-left: 8px !important;\n    }\n  }\n}\n\nion-list.no-padding {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n.text-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nion-toolbar {\n  display: block !important;\n}\n\n@media screen and (max-width: 550px) {\n  ion-title {\n    font-size: 13px !important;\n  }\n}\n\nion-toolbar,\n.toolbar-container {\n  //height:;\n}\n\nion-ripple-effect {\n  color: var(--ion-color-light);\n}\n\nion-title {\n  text-align: center;\n  transform: translateY(-8px);\n}\n\n.text-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.promo-text {\n  margin: 15px 0!important;\n  font-weight: 400 !important;\n}\n\n// ion-select::part(icon) {\n//   color: var(--ion-color-primary);\n// }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
